import React from 'react';
import PropTypes, { shape } from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import formatPrice from '../../../helpers/formatPrice';
import 'react-loading-skeleton/dist/skeleton.css';
import translatedTime from '../../../helpers/translatedTime';

const { pathname } = window.location;
const paths = pathname.split('/');
const linktype = paths[3];

function AccommodationInfo({ accommodations, currency }) {
  return (
    accommodations.length === 0
      ? (
        <>
          <h6>Acomodação:</h6>
          <Skeleton width="50%" />
        </>
      )
      : (
        <>
          <h6>
            {
              accommodations.length === 1
                ? 'Acomodação:'
                : 'Acomodações:'
            }
          </h6>
          <ul>
            { accommodations.map(({
              name: accommodationName,
              duration,
              typePeriod,
              onlyAccommodationWithoutSR,
              onlyAccommodation,
              onlyEnrolWithoutSR,
              onlyEnrol,
            }) => (
              <li key={accommodationName}>
                <p style={{ marginBottom: '0' }}>
                  { `${accommodationName} - ${duration} ${translatedTime[typePeriod]}(s)` }
                  {(linktype !== '2') && (
                  <>
                    {onlyAccommodationWithoutSR
                  && onlyAccommodationWithoutSR > onlyAccommodation && (
                    <>
                      : de &nbsp;
                      <span
                        className="text-decoration-line-through text-danger"
                      >
                        {`${formatPrice(onlyAccommodationWithoutSR, currency)}`}
                      </span>
                      &nbsp; por &nbsp;
                    </>
                    )}
                    { ': '}
                    <span className="blue">
                      {`${formatPrice(onlyAccommodation, currency)}`}
                      {onlyAccommodationWithoutSR
                    && onlyAccommodationWithoutSR > onlyAccommodation && (
                      <>
                        (
                        <span
                          className="blue"
                        >
                          {`${(((onlyAccommodationWithoutSR - onlyAccommodation)
                            / onlyAccommodationWithoutSR) * 100).toFixed(0)}`}
                        </span>
                        %&nbsp;de desconto)
                      </>
                      )}
                    </span>
                  </>
                  )}
                </p>
                {(linktype !== '2') && (
                <>
                  { 'Taxa de reserva: '}
                  {onlyEnrolWithoutSR && onlyEnrolWithoutSR > onlyEnrol && (
                  <>
                    de &nbsp;
                    <span
                      className="text-decoration-line-through text-danger"
                    >
                      {`${formatPrice(onlyEnrolWithoutSR, currency)}`}
                    </span>
                    &nbsp; por &nbsp;
                  </>
                  )}
                </>
                )}

                {(linktype !== '2') && (
                <span className="blue">
                  {`${formatPrice(onlyEnrol, currency)}`}
                  {onlyEnrolWithoutSR && onlyEnrolWithoutSR > onlyEnrol && (
                    <>
                      &nbsp; (
                      <span
                        className="blue"
                      >
                        {`${(((onlyEnrolWithoutSR - onlyEnrol)
                          / onlyEnrolWithoutSR) * 100).toFixed(0)}`}
                      </span>
                      %&nbsp;de desconto)
                    </>
                  )}
                </span>
                )}
              </li>
            )) }
          </ul>
        </>
      )
  );
}

AccommodationInfo.propTypes = {
  accommodations: PropTypes.arrayOf(
    shape({
      name: PropTypes.string,
      duration: PropTypes.number,
      typePeriod: PropTypes.string,
      payment: shape({
        currency: PropTypes.string,
        value: PropTypes.number,
      }),
    }),
  ).isRequired,
  currency: PropTypes.string.isRequired,
};

export default AccommodationInfo;
